// extracted by mini-css-extract-plugin
module.exports = {"root":"creditSection_root__l9I7f","creditLabel":"creditSection_creditLabel__29M7S"};